<template>
    <h2>404</h2>
    <h3>Page not found.</h3>
</template>

<style scoped>
h2 {
  margin-top: 120px;
}

#contain {
  margin: auto!important;
  width: 95%;
  height: 85%;
  position: absolute;
  top: 10%;
  left: 2.5%;
  overflow: auto;
  padding-top: 0.5em!important;
  align-items: center;
}

.header {
  margin: 20px!important;
}

.imgHapiick {
  width: 185px;
}
</style>
